import 'react-datepicker/dist/react-datepicker.css';
import '~components/ui/styles/react-datepicker.css';
import '~components/ui/styles/google-maps.css';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './App';
import AppProvider from './AppProvider';

if (Number(process.env.REACT_APP_ENABLE_MOCKING) !== 0) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  const { worker } = require('./mocks/browser');
  worker.start();
}

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.NODE_ENV;

if (ENV !== 'development' && SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Router>
      <AppProvider>
        <App />
      </AppProvider>
    </Router>
  </StrictMode>,
);
